<anon-headline>
  <ng-container header>
    Stories about
    <mat-form-field class="topic-selector">
      <mat-select (selectionChange)="filterTag = $event.value" [placeholder]="filterTag ? '' : 'all topics'">
        <mat-option *ngIf="filterTag">all topics</mat-option>
        <mat-option *ngFor="let tag of storyTags" [value]="tag">{{tag}}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>
</anon-headline>

<mat-chip-listbox class="type-selector" *ngIf="storyTypes.length > 1"
               (change)="filterType = $event.value ? $event.value.toLowerCase() : 'all'" aria-label="select a story type">
  <mat-chip-option [selected]="filterType == 'all'"
            (click)="filterType = 'all'" [selectable]="filterType != 'all'">All</mat-chip-option>
  <mat-chip-option *ngFor="let type of storyTypes"
            [selected]="filterType == type"
            (click)="filterType = type">{{type | capitalizeFirstLetter}}</mat-chip-option>
</mat-chip-listbox>

<ng-container *ngIf="filteredStories$ | async as stories; else loadingOrError">
  <ng-container *ngIf="stories.length; else empty">
    <section class="stories">
      <article class="story" *ngFor="let story of stories | filterStoriesByType:filterType | filterStoriesByTags:filterTag"
               [routerLink]="[nav_path.stories, story.id]">
        <em class="story-type">{{story.type | capitalizeFirstLetter}}</em>
        <div class="image-container">
          {{story.title?.charAt(0)}}
          <picture *ngIf="story.image">
            <img class="image" [alt]="story.title" [src]="story.image" />
          </picture>
        </div>
        <div class="details">
          <div class="top">
            <div class="left">
              <h3 class="title">
                <anon-story-title [type]="story.type" [status]="story?.problemStatus">{{story.title}}</anon-story-title>
              </h3>
              <p class="byline">{{story.byline}}</p>
            </div>
            <div class="right">
              <!--              <button mat-icon-button><mat-icon>star_outline</mat-icon></button>-->
            </div>
          </div>
          <div class="bottom">
            <p class="author">{{story.author?.name}} <ng-container *ngIf="story.readTime">• <em>{{story.readTime}} min read</em></ng-container></p>
            <p class="created">{{story.created.seconds! * 1000 | dateAgo}}</p>
          </div>
        </div>
      </article>
    </section>
  </ng-container>

  <ng-template #empty>
    <h3>No stories yet, check back soon!</h3>
  </ng-template>
</ng-container>

<ng-template #loadingOrError>
  <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
